import { render, staticRenderFns } from "./GloboGraphicsGhColumns.vue?vue&type=template&id=55a3f98c&scoped=true"
import script from "./GloboGraphicsGhColumns.vue?vue&type=script&lang=js"
export * from "./GloboGraphicsGhColumns.vue?vue&type=script&lang=js"
import style0 from "./GloboGraphicsGhColumns.vue?vue&type=style&index=0&id=55a3f98c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3f98c",
  null
  
)

export default component.exports